// src/components/AssetUploadPreviewImage.js

import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import {
  ImageOutlined as ImageOutlinedIcon,
  ImageNotSupportedOutlined as ImageNotSupportedOutlinedIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export default function AssetUploadPreviewImage({ file }) {
  const { t } = useTranslation();
  const getImagePreview = () => {
    if (file.sourceUrl) {
      return (
        <>
          <img
            src={file.sourceUrl}
            alt="preview"
            style={{ width: '100%', objectFit: 'cover' }}
          />
        </>
      );
    }

    if (file.error) {
      return (
        <>
          <ImageNotSupportedOutlinedIcon sx={{ fontSize: '48px' }} />
          <Typography fontSize={14}>{t('errorSimple')}</Typography>
        </>
      );
    }

    return (
      <>
        <ImageOutlinedIcon sx={{ fontSize: '48px' }} />
        <Typography fontSize={14}>{t('pending')}</Typography>
      </>
    );
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      border="1px solid #d8d8d8"
      color="#757575"
      bgcolor="#fafafa"
      margin={0}
      sx={{
        width: '100%',
        // For tablets and up, limit maxWidth and auto-center
        maxWidth: {
          sm: 500,
        },
        margin: '0 auto',
      }}
    >
      {getImagePreview()}
    </Box>
  );
}
